import tabel from './view.vue'
const CgTable = {
  	install: function (Vue) {
    	Vue.component('CgTable', tabel)
  	}
}
export default CgTable



// WEBPACK FOOTER //
// ./src/components/cg_tabel/index.js